// extracted by mini-css-extract-plugin
var _1 = "AttachedRequestRecipientTag-moduleattachedRequestRecipientTag__atDHX Tag-moduleTag__FLr9H";
export { _1 as "attachedRequestRecipientTag" }
